import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Utility from "../../Utility/Utility";

import { getSponserListApi, getTeamListApi, createMatchApi, getRefereeListApi } from "./MatchController"
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";

const CreateMatch = () => {

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { tournamentId } = useParams();
    const { language } = useSelector((state) => state.language);
    const { userDetails, token, userType } = useSelector((state) => state.user);

    const [openTeamA, setOpenTeamA] = useState(false);
    const [openTeamB, setOpenTeamB] = useState(false);
    const [openReferee, setOpenReferee] = useState(false);
    const [selectedTeamA, setSelectedTeamA] = useState("");
    const [selectedTeamB, setSelectedTeamB] = useState("");
    const [selectedReferee, setSelectedReferee] = useState("");
    const teamARef = useRef(null);
    const teamBRef = useRef(null);
    const refereeRef = useRef(null);

    const [refereeList, setTournamentTypeList] = useState([]);
    const [teamList, setTeamList] = useState([]);
    const [sponserList, setSponserList] = useState([]);


    useEffect(() => {
        getTeamList();
        getSponserList();
        getRefereeList();
    }, []);

    const getTeamList = () => {
        try {
            dispatch(loaderStateTrue());
            getTeamListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setTeamList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getSponserList = () => {
        try {
            dispatch(loaderStateTrue());
            getSponserListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setSponserList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getRefereeList = () => {
        try {
            dispatch(loaderStateTrue());
            getRefereeListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setTournamentTypeList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    useEffect(() => {
        const handler = (e) => {
            if (teamARef.current && !teamARef.current.contains(e.target)) {
                setOpenTeamA(false);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const activeTeamA = teamList.find((c) => c._id === selectedTeamA);

    useEffect(() => {
        const handler = (e) => {
            if (teamBRef.current && !teamBRef.current.contains(e.target)) {
                setOpenTeamB(false);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const activeTeamB = teamList.find((c) => c._id === selectedTeamB);

    useEffect(() => {
        const handler = (e) => {
            if (refereeRef.current && !refereeRef.current.contains(e.target)) {
                setOpenReferee(false);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const activeReferee = refereeList.find((c) => c._id === selectedReferee);

    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState([]);

    const dropdownRef = useRef(null);

    // ==== Outside Click Handler ====
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (item) => {
        if (!selected.some((s) => s._id === item._id)) {
            setSelected([...selected, item]);
        }
        setIsOpen(false);
    };

    const handleOnSelect = (item) => {
        if (!selected.some((s) => s._id === item._id)) {
            setSelected([...selected, item]);
        }
        setIsOpen(false);
    };

    const handleRemove = (_id) => {
        setSelected(selected.filter((s) => s._id !== _id));
    };

    console.log("selectedselectedselectedselected", selected)
    // const sponsor = selected.map(item => item._id);
    // console.log("sponsorsponsorsponsorsponsor", sponsor)

    const [matchData, setMatchData] = useState({
        referee: "",
        // sponsor: sponsor,
        teams: [],
        matchDate: "",
        matchTime: "",
        matchRound: "",
        matchNo: "",
        venue: "",
        tournament: "",
    });

    const [matchError, setMatchError] = useState({
        referee: "",
        teams: [],
        // sponsor: [],
        matchDate: "",
        matchTime: "",
        venue: "",
        tournament: "",
        matchRound: "",
        matchNo: '',
    });

    const validateLogin = () => {
        let valid = true;
        if (matchData.referee.trim() === "") {
            valid = false;
            setMatchError({ ...matchError, referee: t("requiredField") });
        } else {
            setMatchError({ ...matchError, referee: "" });
        }
        return valid;
    };

    const handleCreate = () => {
        let valid = validateLogin();
        if (valid) {
            let data = {
                ...matchData,
                // sponsor: selected.map(item => item._id),
                tournament: tournamentId
            };
            dispatch(loaderStateTrue());
            createMatchApi(data)
                .then(async (response) => {
                    console.log("responseresponseresponseresponse", response)
                    if (response.status) {
                        setTimeout(() => {
                            dispatch(loaderStateFalse());
                            navigate(`/${language}/dashboard`);
                        }, 1000);
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        dispatch(loaderStateFalse());
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    Utility.toastNotifications(
                        error.response.data.message,
                        "Error",
                        "error"
                    );
                    if (error.response.status === 401) {
                        Utility.toastNotifications(
                            error.response.data.message,
                            "Error",
                            "error"
                        );
                    }
                    dispatch(loaderStateFalse());
                });
        }
    };

    const updateTeam = (index, value) => {
        setMatchData((prev) => {
            const updated = [...prev.teams];
            updated[index] = value;

            return {
                ...prev,
                teams: updated,
            };
        });
    };

    const filteredTeamListForA = teamList.filter(
        (team) => team._id !== matchData.teams[1]
    );

    const filteredTeamListForB = teamList.filter(
        (team) => team._id !== matchData.teams[0]
    );


    return (
        <main class="main p-4 relative">
            <div class="flex flex-col">
                <div class="flex flex-wrap items-start gap-y-6 -mx-2">
                    <div class="lg:w-4/6 w-full px-2">
                        <div className="space-y-5">
                            <div className="relative">
                                <div className="relative rounded-xl bg-gray-50 h-full">
                                    <div className='absolute inset-0 rounded-xl overflow-hidden'>
                                        <div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute -top-[1vw] -right-[2vw] opacity-80"></div>
                                        <div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute -top-[6vw] right-[5vw]"></div>
                                        <div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute -bottom-[6vw] right-[15vw]"></div>
                                    </div>
                                    <div className="flex max-sm:flex-wrap gap-3 justify-between relative">
                                        <div className="p-5 flex flex-col items-start justify-center [&_h1_strong]:text-primary-500 space-y-3 [&_strong]:text-primary-500">
                                            <div className="space-y-2">
                                                <h2 className="lg:text-4xl md:text-3xl text-xl font-black uppercase">Create a new Match</h2>
                                                <p className='text-base font-medium text-gray-400'>Dummy text of the printing and typesetting industry.</p>
                                            </div>
                                        </div>
                                        <div className="lg:-mt-4 text-center">
                                            <img src="assets/images/football-stadium2.png" alt="" className="w-full inline-block rounded-br-xl" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap gap-y-4 -mx-2">
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('referee')}</label>
                                    <div className="dropdown border rounded-lg bg-white relative">
                                        <div className="relative z-[1]" ref={refereeRef}>
                                            <button
                                                className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                                                onClick={() => setOpenReferee(!openReferee)}
                                            >
                                                <span>
                                                    <img src={activeReferee?.photo} className="size-5" alt="" />
                                                    {activeReferee?.fullName}
                                                </span>
                                                <img
                                                    src="assets/images/icons/arrow-chevron-downward.svg"
                                                    className={`ml-auto transition-transform ${openReferee ? "rotate-180" : ""
                                                        }`}
                                                    alt=""
                                                />
                                            </button>
                                            <div
                                                className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-64 overflow-auto transition-all
                                        ${openReferee
                                                        ? "opacity-100 visible scale-100"
                                                        : "opacity-0 invisible scale-95"
                                                    }`}
                                            >
                                                <ul>
                                                    {refereeList.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedReferee === item?._id
                                                                    ? "bg-gray-200 font-semibold"
                                                                    : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedReferee(item?._id);
                                                                setMatchData({
                                                                    ...matchData,
                                                                    referee: item?._id,
                                                                });
                                                                setMatchError({ ...matchError, referee: "" });
                                                                setOpenReferee(false);
                                                            }}
                                                        >
                                                            <img src={item?.photo} className="size-5" alt="" />
                                                            {item?.fullName}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-red-500">{matchError.referee}</span>
                                        </div>
                                    </div>
                                    <span className="text-red-500"></span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('matchDate')}</label>
                                    <input
                                        type="date"
                                        id=""
                                        placeholder="Select Date"
                                        className="form-control"
                                        onChange={(e) => {
                                            setMatchData({ ...matchData, matchDate: e.target.value });
                                            setMatchError({ ...matchError, matchDate: "" });
                                        }}
                                        value={matchData.matchDate}
                                    />
                                    <span className="text-red-500">{matchError?.matchDate}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('matchTime')}</label>
                                    <input
                                        type="time"
                                        id=""
                                        placeholder="Select Date"
                                        className="form-control"
                                        onChange={(e) => {
                                            setMatchData({ ...matchData, matchTime: e.target.value });
                                            setMatchError({ ...matchError, matchTime: "" });
                                        }}
                                        value={matchData?.matchTime}
                                    />
                                    <span className="text-red-500">{matchError?.matchTime}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('venue')}</label>
                                    <input
                                        type="text"
                                        id=""
                                        placeholder="Enter a Venue"
                                        className="form-control"
                                        onChange={(e) => {
                                            setMatchData({ ...matchData, venue: e.target.value });
                                            setMatchError({ ...matchError, venue: "" });
                                        }}
                                        value={matchData.venue}
                                    />
                                    <span className="text-red-500">{matchError?.venue}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('teamA')}</label>
                                    <div className="dropdown border rounded-lg bg-white relative">
                                        <div className="relative z-[1]" ref={teamARef}>
                                            <button
                                                className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                                                onClick={() => setOpenTeamA(!openTeamA)}
                                            >
                                                <img
                                                    src={activeTeamA?.logo}
                                                    className="size-6 rounded-full"
                                                    alt=""
                                                />
                                                <span>{activeTeamA?.name}</span>
                                                <img
                                                    src="assets/images/icons/arrow-chevron-downward.svg"
                                                    className={`ml-auto transition-transform ${openTeamA ? "rotate-180" : ""
                                                        }`}
                                                    alt=""
                                                />
                                            </button>
                                            <div
                                                className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-64 overflow-auto scrollbar-custom transition-all
                                        ${openTeamA
                                                        ? "opacity-100 visible scale-100"
                                                        : "opacity-0 invisible scale-95"
                                                    }`}
                                            >
                                                <ul>
                                                    {filteredTeamListForA.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedTeamA === item?._id
                                                                    ? "bg-gray-200 font-semibold"
                                                                    : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedTeamA(item?._id);
                                                                updateTeam(0, item?._id);
                                                                setMatchError({ ...matchError, teamA: "" });
                                                                setOpenTeamA(false);
                                                            }}
                                                        >
                                                            <img src={item?.logo} className="size-6 object-cover rounded-full" alt="" />
                                                            {item?.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-red-500">{matchError?.teamA}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('teamB')}</label>
                                    <div className="dropdown border rounded-lg bg-white relative">
                                        <div className="relative z-[1]" ref={teamBRef}>
                                            <button
                                                className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                                                onClick={() => setOpenTeamB(!openTeamB)}
                                            >
                                                <img
                                                    src={activeTeamB?.logo}
                                                    className="size-6 rounded-full"
                                                    alt=""
                                                />
                                                <span>{activeTeamB?.name}</span>

                                                <img
                                                    src="assets/images/icons/arrow-chevron-downward.svg"
                                                    className={`ml-auto transition-transform ${openTeamB ? "rotate-180" : ""
                                                        }`}
                                                    alt=""
                                                />
                                            </button>

                                            {/* Country Menu */}
                                            <div
                                                className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-64 overflow-auto scrollbar-custom transition-all
                                        ${openTeamB
                                                        ? "opacity-100 visible scale-100"
                                                        : "opacity-0 invisible scale-95"
                                                    }`}
                                            >
                                                <ul>
                                                    {filteredTeamListForB.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedTeamB === item?._id
                                                                    ? "bg-gray-200 font-semibold"
                                                                    : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedTeamB(item?._id);
                                                                updateTeam(1, item?._id);
                                                                setMatchError({ ...matchError, teamB: "" });
                                                                setOpenTeamB(false);
                                                            }}
                                                        >
                                                            <img src={item?.logo} className="size-6 object-cover rounded-full" alt="" />
                                                            {item?.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-red-500">{matchError?.teamB}</span>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="xs:w-full w-full px-2">
                                    <label className="form-label">{t('addSponsor')}</label>
                                    <div className="w-full relative" ref={dropdownRef}>
                                        <div className="border px-4 py-2.5 rounded-md cursor-pointer bg-white"
                                            onClick={() => setIsOpen(!isOpen)}
                                        >
                                            <span className="font-medium">Select sponsor...</span>
                                        </div>
                                        {isOpen && (
                                            <div className="absolute z-20 mt-1 bg-white border rounded-lg shadow-lg w-full max-h-56 overflow-auto">
                                                {sponserList.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        className="flex items-center gap-3 p-2 hover:bg-gray-100 cursor-pointer"
                                                        onClick={() => handleSelect(item)}
                                                    >
                                                        <img src={item?.photo} alt="" className="w-6 h-6 object-contain" />
                                                        <span className="font-medium">{item?.fullName}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        <div className="flex gap-2 mt-3 flex-wrap">
                                            {selected.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full"
                                                >
                                                    <img src={item?.photo} alt="" className="w-5 h-5 object-contain" />
                                                    <span>{item?.fullName}</span>

                                                    <button
                                                        className="text-red-500 font-bold"
                                                        onClick={() => handleRemove(item?._id)}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div> */}
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('Select Round')}</label>
                                    <select
                                        name="matchRound"
                                        id=""
                                        className='form-select'
                                        onChange={() => handleOnSelect()}
                                    >
                                        <option value="01">Round 01</option>
                                        <option value="02">Round 02</option>
                                        <option value="03">Round 03</option>
                                        <option value="semi final">Semi Final</option>
                                        <option value="final">Final</option>
                                    </select>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('matchNo')}</label>
                                    <input
                                        type="number"
                                        id="matchNo"
                                        placeholder="Match No"
                                        className="form-control"
                                        onChange={(e) => {
                                            setMatchData({ ...matchData, matchNo: e.target.value });
                                            setMatchError({ ...matchError, matchNo: "" });
                                        }}
                                        value={matchData?.matchNo}
                                    />
                                    <span className="text-red-500">{matchError?.matchNo}</span>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-start gap-4 p-3 rounded-lg bg-gray-50">
                                <div>
                                    <h3 className="text-lg font-extrabold uppercase">Notes</h3>
                                    <p className="text-gray-400">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
                                <button
                                    className="btn btn-primary text-nowrap ml-auto"
                                    // onClick={() => navigate("/en/team-management")}
                                    onClick={handleCreate}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-2/6 w-full px-2 sticky top-20">
                        <div className="space-y-5">
                            <div className="relative">
                                <div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
                                    <div className="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-[#3D54AC]"></div>
                                    <div className="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
                                </div>
                                <div className="relative bg-cover bg-no-repeat bg-center h-full">
                                    <div className="flex lg:justify-center justify-center max-sm:flex-wrap gap-y-3 w-full">
                                        <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                                            <img src="assets/images/teams.png" alt="" className="max-w-full lg:max-h-[276px] inline-block" />
                                        </div>
                                    </div>
                                    <div className="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-center gap-6 bg-gradient-to-t from-[#3D54AC] rounded-b-xl overflow-hidden">
                                        <div className="">
                                            <div className="space-y-2">
                                                <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">{t('createTeam')}</h4>
                                            </div>
                                        </div>
                                        <div className="">
                                            <button className="btn btn-primary text-nowrap ml-auto" onClick={() => navigate(`/${language}/create-team`)}>{t('seeAll')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default CreateMatch